import { Formik } from "formik";
import * as Yup from "yup";
import TemplateForm from "../../../../atoms/TemplateForm";
import InputField from "../../../../atoms/InputField";
import moment from "moment";
import { REGISTER_QUEJA } from "../../../../../api/apiQuejas";
import { SEND_INCIDENT_EMAIL } from "../../../../../api/apiEmails";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const CreateQYR = ({ refetch, onClose }) => {
    const { im } = useParams();

    const handleSubmit = async (values, { setIsSubmitting }) => {
        try {
            const newValues = {
                incident_date: moment().format("YYYY-MM-DD"),
                ...values
            };

            // Registrar la queja
            await REGISTER_QUEJA(newValues);
            toast.success("Creado correctamente");

            // Enviar email
            const emailData = {
                toAddress: "rcph12345@gmail.com",
                propertie: values.propertieId,
                incident_date: moment().format("YYYY-MM-DD"),
                staff: "Sistema",
                description: values.description
            };

            await SEND_INCIDENT_EMAIL(emailData);
            toast.success("Email enviado a los responsables");

            refetch();
            onClose();
        } catch (error) {
            console.error(error);
            toast.error("Error al crear intente más tarde");
        } finally {
            setIsSubmitting(false);
        }
    };

    const initialValues = {
        description: "",
        incident_date: moment().format("YYYY-MM-DD"),
        comment_user: "",
        status: "Pendiente",
        propertieId: Number(im),
    };

    const validationSchema = Yup.object({
        comment_user: Yup.string()
            .max(255, "Máximo 255 caracteres")
    });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ isSubmitting }) => (
                <TemplateForm
                    fields={
                        <>
                            <InputField name="description" label="Incidente" placeholder="Queja o sugerencia" />
                            <InputField name="incident_date" label="Fecha del incidente" type="date" disabled placeholder={moment().format("YYYY-MM-DD")} />
                            <div className="w-full col-span-2">
                                <InputField name="comment_user" label="Comentarios" type="textarea" />
                            </div>
                        </>
                    }
                    isSubmitting={isSubmitting}
                    textButton="Aceptar"
                />
            )}
        </Formik>
    );
};

export default CreateQYR;